import createFromRecipientWell from '../utils/createFromRecipientWell';
import switchToReadWriteRecipient from './switchToReadWriteRecipient';
import { action } from 'satcheljs/lib/legacy';
import datapoints from '../datapoints';
export default action('toggleFrom', datapoints.ComposeCommandShowFrom)(function toggleFrom(viewState) {
    viewState.fromViewState.isFromShown = !viewState.fromViewState.isFromShown;
    if (viewState.fromViewState.isFromShown && !viewState.fromViewState.from) {
        viewState.fromViewState.from = createFromRecipientWell(null, viewState.referenceItemId);
    }
    // Readonly recipient well should be changed to readwrite recipient well when show from.
    if (viewState.fromViewState.isFromShown && viewState.showCompactRecipientWell) {
        switchToReadWriteRecipient(viewState);
    }
});
//# sourceMappingURL=toggleFrom.js.map